import type { AddressData, AddressInfo } from './CustomerAddressTypes';
import { ADDRESS_SEPARATOR } from '../constants';

export type CustomerAddresses = {
    primaryAddress: AddressData;
    billingAddress?: AddressData;
};

export const extractCustomerAddressFields = (addressData: AddressData): AddressData => ({
    streetAddress: addressData.streetAddress,
    streetAddress2: addressData.streetAddress2,
    city: addressData.city,
    state: addressData.state,
    zip: addressData.zip,
    county: addressData.county
});

export const getFormattedAddress = (addressData: AddressData): string[] => {
    return [
        [addressData.streetAddress, addressData.streetAddress2].filter(Boolean).join(`,${ADDRESS_SEPARATOR}`),
        [`${addressData.city ? addressData.city + ',' : ''}`, addressData.state, addressData.county, addressData.zip]
            .filter(Boolean)
            .join(ADDRESS_SEPARATOR)
    ].filter(Boolean);
};

export const isAddressesEqual = (currentAddresses: AddressInfo[], buyerAddress: CustomerAddresses): boolean => {
    const buyerPrimary = extractCustomerAddressFields(buyerAddress.primaryAddress);
    const buyerBilling = buyerAddress.billingAddress && extractCustomerAddressFields(buyerAddress.billingAddress);

    return (
        JSON.stringify(currentAddresses[0]?.data) !== JSON.stringify(buyerPrimary) ||
        JSON.stringify(currentAddresses[1]?.data) !== JSON.stringify(buyerBilling)
    );
};
